import BudgetComponentListAlert from 'components/Alert/BudgetComponentList';
import DangerDeleteAlert from 'components/Alert/DangerDelete';
import GenericAlert from 'components/Alert/Generic';

export default {
  genericAlert: GenericAlert,
  dangerDeleteAlert: DangerDeleteAlert,
  budgetComponentListAlert: BudgetComponentListAlert,
};
